export var defaultProps = {
  type: "text",
  size: "default",
  isPlaceholderVisibleWhenHasValue: true,
  backgroundColor: "backgroundLight"
};

// eslint-disable-next-line no-shadow
export var InputTypes = /*#__PURE__*/function (InputTypes) {
  InputTypes["TEXT"] = "text";
  InputTypes["PASSWORD"] = "password";
  InputTypes["FILE"] = "file";
  return InputTypes;
}({});